import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
import { chameleonNumberField } from '../NumberField/NumberField.definition';
import { chameleonSvg } from '../Svg';
import { chameleonInputStepper } from './InputStepper.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonInputStepper({ prefix }), chameleonSvg({ prefix }), chameleonNumberField({ prefix }), chameleonIconButton({ prefix }));
}
